import { Component, OnInit } from '@angular/core';
import { SidePanelService } from '../shared/services/side-pannel/side-pannel.service';
import { AmaService } from './ama.service';

@Component({
  selector: 'app-ama',
  templateUrl: './ama.component.html',
  styleUrls: ['./ama.component.scss']
})
export class AmaComponent implements OnInit {

  accessRoles: any;
  constructor(
    public amaService:AmaService,
    public sidePanelService:SidePanelService
    ) { 
      this.sidePanelService.initSideDrawer('ama');
      this.accessRoles = JSON.parse(localStorage.getItem('access'));
    }

  ngOnInit() {
  }

}
